"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NodeValueHandlerAdapter_1 = require("./NodeValueHandlerAdapter");
/**
 * Converts GraphQL objects to triple patterns by converting keys to predicates and values to objects.
 */


var NodeValueHandlerObject =
/*#__PURE__*/
function (_NodeValueHandlerAdap) {
  _inherits(NodeValueHandlerObject, _NodeValueHandlerAdap);

  function NodeValueHandlerObject(util, settings) {
    _classCallCheck(this, NodeValueHandlerObject);

    return _possibleConstructorReturn(this, _getPrototypeOf(NodeValueHandlerObject).call(this, 'ObjectValue', util, settings));
  }

  _createClass(NodeValueHandlerObject, [{
    key: "handle",
    value: function handle(valueNode, fieldName, convertContext) {
      // Convert object keys to predicates and values to objects, and link them both with a new blank node.
      var subject = this.util.dataFactory.blankNode();
      var auxiliaryObjectPatterns = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = valueNode.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var field = _step.value;
          var subValue = this.util.handleNodeValue(field.value, fieldName, convertContext);
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = subValue.terms[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var term = _step2.value;
              auxiliaryObjectPatterns.push(this.util.createQuadPattern(subject, field.name, term, convertContext.graph, convertContext.context));
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          if (subValue.auxiliaryPatterns) {
            auxiliaryObjectPatterns = auxiliaryObjectPatterns.concat(subValue.auxiliaryPatterns);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return {
        terms: [subject],
        auxiliaryPatterns: auxiliaryObjectPatterns
      };
    }
  }]);

  return NodeValueHandlerObject;
}(NodeValueHandlerAdapter_1.NodeValueHandlerAdapter);

exports.NodeValueHandlerObject = NodeValueHandlerObject;